import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  delete(keyName: string): void {
    localStorage.removeItem(keyName);
  }

  deleteAll(): void {
    const keys = Object.keys(localStorage);

    keys.forEach(key => {
      localStorage.removeItem(key);
    });
  }

  deleteArray(keyNames: Array<string>): void {
    keyNames.forEach(key => localStorage.removeItem(key));
  }

  getkeyName(keyName: string): any {
    const valueString = localStorage.getItem(keyName);

    return JSON.parse(valueString);
  }

  set(keyName: string, value: Object): void {
    const valueString = JSON.stringify(value);

    localStorage.setItem(keyName, valueString);
  }

  update(keyName: string, value: Object): void {
    const valueKeys = Object.keys(value);
    const valueString = localStorage.getItem(keyName);
    let valueObject = JSON.parse(valueString);

    if (!valueObject) {
      valueObject = {};
    }

    for (const key of valueKeys) {
      valueObject[key] = value[key];
    }

    localStorage.setItem(keyName, JSON.stringify(valueObject));
  }
}
